import { Formik } from 'formik';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react'
import SmallLoader from '../../../SmallLoader';
import { MdError } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import getPlatformInfo, { notifySuccess } from '../../../../action/customFn';
import axios from "../../../../axios";
import { setLogin } from '../../../../action/loginAction';
import { useNavigate } from 'react-router-dom';
import OTPInput from 'react-otp-input';

function ForgotPasswordForm({ googleError, setFormStage }) {
  const userIpInfo = useSelector(state => state?.paymentData?.userIpInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
      <Formik
        initialValues={{ email: '' }}
        validate={values => {
          const errors = {};
          if (!values.email) {
            errors.email = 'Email is Required';
          } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
          ) {
            errors.email = 'Invalid email address';
          }
          return errors;
        }}
        onSubmit={async (values, { setSubmitting, setStatus }) => {
          try {
            const url = "/user/forgot-password";
            const postData = {
              email: values.email.toLocaleLowerCase(),
            };
            const res = await axios.post(url, postData);
            const { message } = res.data;
            notifySuccess(message);
            localStorage.setItem("otp_email", values.email);
            setStatus({ success: true });
            setSubmitting(false);
            // navigate("/login/verify-otp")
            setFormStage("VERIFY__OTP");
          } catch (error) {
            console.log(error);
            setStatus({ success: false, error: true, message: error.response?.data?.message })
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          status,
          setFieldValue
        }) => (
          <AnimatePresence>
          <motion.form initial={{ opacity: 0}} animate={{ opacity: 1}} transition={{duration:0.4}} exit={{ opacity: 0}} onSubmit={handleSubmit}>
            <AnimatePresence>
              {(status?.error || googleError?.error) && <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="error-holder">
                <div style={{ width: "20px", fontSize: "20px" }}>
                  <MdError />
                </div>
                <span>{status?.message || googleError?.msg}</span>
              </motion.div>}
            </AnimatePresence>
            {!status && <div style={{ marginTop: "20px" }}></div>}
            <AnimatePresence>
              {
                errors.email && touched.email && (
                  <motion.div key={"email_error_msg"} style={{ margin: "0px", marginBottom: "-10px", color: "#d3351a", fontWeight: "600", fontSize: "13px" }} initial={{ opacity: 0, height: 0 }} exit={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} >{errors.email && touched.email && errors.email}</motion.div>
                )
              }
            </AnimatePresence>
            <div style={{ position: "relative" }}>
              <input id="login__email" value={values.email} onChange={handleChange} onBlur={handleBlur} type="email" name="email" placeholder="Enter your email" style={errors.email && touched.email ? { border: "2px solid #d3351a" } : {}} />
              {errors.email && touched.email && <MdError style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "20px", color: "#d3351a" }} />}
            </div>

            <button disabled={isSubmitting} className="submit" type="submit" >
              {isSubmitting ? <SmallLoader color={"#ffff"} /> : "Send OTP"}
            </button>
            <button onClick={() => { navigate("/login") }} disabled={isSubmitting} style={{ background: "rgba(12,12,55,0.05)" }} className="submit submit-secondary" type="button" >
              Cancel
            </button>
          </motion.form>
          </AnimatePresence>
        )}
      </Formik>
  )
}

export default ForgotPasswordForm
